import { useState, useEffect, useRef } from "react";
import { db } from "../util/firebase";
import { doc, updateDoc } from "firebase/firestore";
import { Button, Textarea, Stack } from "@chakra-ui/react";
import { Icon } from "@chakra-ui/icons";
import { FaUndo } from "react-icons/fa";

function RejectFile({ id, state, file, index }) {
  const [disabled, setDisabled] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  function handleChange() {
    let value = inputRef.current.value;
    if (value.length > 10 && disabledButton) {
      setDisabledButton(false);
    }
    if (value.length < 10 && !disabledButton) {
      setDisabledButton(true);
    }
  }

  async function handleClick() {
    setLoading(true);
    let value = inputRef.current.value;
    const docRef = doc(db, "providers", id);
    try {
      await updateDoc(docRef, {
        [file]: 2,
        [`messageFile${index + 1}`]: value,
      });
      inputRef.current.value = "";
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    if (state === 2 || state === 0) {
      setDisabled(true);
      setDisabledButton(true);
    } else {
      setDisabled(false);
    }
  }, [state]);

  return (
    <>
      <Stack minWidth="150px" w="100%">
        <Textarea
          onChange={handleChange}
          type="text"
          disabled={disabled}
          ref={inputRef}
          maxLength={144}
          size="xs"
          rounded={2}
          rows={2}
        />
        <Button
          colorScheme="red"
          size="xs"
          disabled={disabledButton}
          onClick={handleClick}
          rounded={2}
          mt={2}
          leftIcon={<Icon as={FaUndo} />}
          loadingText="Actualizando"
          isLoading={loading}
        >
          Rechazar
        </Button>
      </Stack>
    </>
  );
}

export default RejectFile;
